import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from 'components/v2/Button'
import { Column } from '@10xLabs/react-web/components/Column'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import Heading from 'components/v2/Heading'
import { Row } from '@10xLabs/react-web/components/Row'
import { Table, Thead, Tbody, Tr, Th, Td } from '@10xLabs/react-web/components/Table'
import FormLayout from 'features/App/components/FormLayout'
import { InStockError } from 'features/Inventories/components/InStockError'
import { ORDER_TYPE } from 'features/Inventories/components/OrderType/constants'
import { getItemLabel } from 'features/Snacks/components/ItemAutocomplete'
import { getUnprocessableErrors, isInStockError } from 'utils/error'

export const BulkItemsSummary = (props: TSFixMe): TSFixMe => {
  let inStockErrors: TSFixMe = []
  let filteredUnprocessableErrors: TSFixMe = []
  const { values, handleSubmit, error, loading, onCancel } = props

  const intl = useIntl()

  if (error) {
    const unprocessableErrors = getUnprocessableErrors(error)
    filteredUnprocessableErrors = unprocessableErrors.filter((unprocessableError): TSFixMe => {
      return !isInStockError(unprocessableError)
    })
    inStockErrors = unprocessableErrors.filter((unprocessableError): TSFixMe => {
      return isInStockError(unprocessableError)
    })
  }

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <FormLayout.CardContent>
        <Row>
          <Column>
            <Heading.H5>
              <FormattedMessage id="spanish.inventories.receiveBulkItems.form.summary.title" defaultMessage="Resumen" />
            </Heading.H5>
          </Column>
        </Row>

        <Row>
          <Column>
            <Table>
              <Thead>
                <Tr>
                  <Th>
                    <FormattedMessage
                      id="spanish.inventories.receiveBulkItems.summary.quantity.label"
                      defaultMessage="Cantidad"
                    />
                  </Th>

                  <Th>
                    <FormattedMessage
                      id="spanish.inventories.receiveBulkItems.summary.items"
                      defaultMessage="Productos"
                    />
                  </Th>

                  {values.type !== ORDER_TYPE.SHIPMENT && (
                    <Th>
                      <FormattedMessage
                        id="spanish.inventories.receiveBulkItems.summary.unitPrice"
                        defaultMessage="Precio unitario"
                      />
                    </Th>
                  )}
                </Tr>
              </Thead>

              <Tbody>
                {values.items.map((item: TSFixMe, index: TSFixMe): TSFixMe => {
                  return (
                    <Tr key={index}>
                      <Td>
                        {item.isPackage && item.isMixed && (
                          <FormattedMessage
                            id="spanish.inventories.receiveBulkItems.summary.quantity.mixed"
                            defaultMessage="{quantity, plural,
                              one {1 paquete surtido}
                              other {# paquetes surtidos}
                            }"
                            values={{
                              quantity: parseInt(item.packagesQuantity)
                            }}
                          />
                        )}

                        {item.isPackage && !item.isMixed && (
                          <FormattedMessage
                            id="spanish.inventories.receiveBulkItems.summary.quantity.package"
                            defaultMessage="{quantity, plural,
                              one {1 paquete}
                              other {# paquetes}
                            }"
                            values={{
                              quantity: parseInt(item.packagesQuantity)
                            }}
                          />
                        )}

                        {!item.isPackage && (
                          <FormattedMessage
                            id="spanish.inventories.receiveBulkItems.summary.quantity.unit"
                            defaultMessage="{quantity, plural,
                              one {1 unidad}
                              other {# unidades}
                            }"
                            values={{
                              quantity: parseInt(item.nestedItems[0].quantity)
                            }}
                          />
                        )}
                      </Td>

                      <Td>
                        {item.isPackage && (
                          <>
                            {item.nestedItems.map((nestedItem: TSFixMe, nestedItemIndex: TSFixMe): TSFixMe => {
                              return (
                                <div key={nestedItemIndex}>
                                  {nestedItem.quantity} {getItemLabel(nestedItem, intl)}
                                </div>
                              )
                            })}
                          </>
                        )}

                        {!item.isPackage && !item.isMixed && <>{getItemLabel(item.nestedItems[0], intl)}</>}
                      </Td>

                      {values.type !== ORDER_TYPE.SHIPMENT && (
                        <Td>
                          {/* @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message*/}
                          <FormattedPrice value={parseInt(item.nestedItems[0].price * 100)} />
                        </Td>
                      )}
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </Column>
        </Row>
      </FormLayout.CardContent>

      <FormLayout.Split />

      <FormLayout.CardFooter>
        <InStockError errors={inStockErrors} />

        {error && inStockErrors.length === 0 && (
          <div>
            <ErrorMessage errors={filteredUnprocessableErrors}>
              <FormattedMessage
                id="spanish.inventories.receiveBulkItems.form.error"
                defaultMessage="Hubo un error. Intenta de nuevo."
              />
            </ErrorMessage>
          </div>
        )}

        <FormLayout.CardFooterActions>
          <Button type="button" kind="cancel" onClick={onCancel}>
            <FormattedMessage id="spanish.inventories.receiveBulkItems.form.back" defaultMessage="Regresar" />
          </Button>

          <Button type="submit" kind="primary" loading={loading}>
            <FormattedMessage id="spanish.dictionary.save" defaultMessage="Guardar" />
          </Button>
        </FormLayout.CardFooterActions>
      </FormLayout.CardFooter>
    </form>
  )
}
